/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Move_UpInputs */



/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Rooms_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_move_up = /** @type {((inputs?: Rooms_Move_UpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Move_UpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Monter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mover para cima")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta su")
	return /** @type {LocalizedString} */ ("Move up")
});